import { memo, useCallback } from "react";

// Servisni sloj
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";

// UI
import FileUploadControl from "ui/components/FileUpload/FileUploadControl/FileUploadControl";

import { ServiceDocumentFormProps } from "./types";

/**
 * Zadnji korak naloga — dokumentacija zahvata. Računi se ovdje ne prilažu: oni idu uz
 * trošak, koji nosi i vezu na stavku ulaznog računa.
 */
const ServiceDocumentForm: React.FC<ServiceDocumentFormProps> = (props) => {
  const { uploads, onChange } = props;

  const handleUploadSave = useCallback(
    (saved: FleetDocumentUpload[]) => {
      onChange([...uploads, ...saved]);
    },
    [uploads, onChange]
  );

  const handleUploadDelete = useCallback(
    (id: string) => {
      onChange(uploads.filter((upload) => upload.id !== id));
    },
    [uploads, onChange]
  );

  return (
    <div className="flex items-start justify-center px-4 pt-12 pb-6">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1mb-2">
          Dokumentacija
        </h1>
        <p className="text-center text-md text-slate-500 mb-8">
          Radni nalog, primopredajni zapisnik, jamstvo — sve što stigne uz zahvat.
        </p>

        <div className="border bg-white border-slate-200">
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">
                Dokumenti
              </h3>
              <p className="text-xs text-slate-500">
                Račune priložite uz trošak, ne ovdje
              </p>
            </div>
            <FileUploadControl
              uploads={uploads}
              onUploadSave={handleUploadSave}
              onUploadDelete={handleUploadDelete}
              buttonText="Dodaj dokumente"
              modalTitle="Upload dokumenta"
              emptyText="Dodajte dokumente vezane uz servisni nalog"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ServiceDocumentForm);
